export const isIncluded = (array, value) => array?.some((owner) => owner._id === value);
